import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import classnames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button';
import { scrollToElement } from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import CreateAccountPage from 'yoda-account-components/lib/components/CreateAccount/Page/CreateAccountConnect';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { signInPageLabels } from '../../../../../common/LabelConstants';
import * as styles from './CreateAccountButton.css';

const cx = classnames.bind(styles);

class CreateAccountButton extends Component {
    static propTypes = {
        checkoutSessionInit: PropTypes.func.isRequired,
        showGlobalLoader: PropTypes.bool,
    };

    static defaultProps = {
        showGlobalLoader: false,
    };

    constructor() {
        super();
        this.state = {
            expandForm: false,
        };
        this.scrollToElement = this.scrollToElement.bind(this);
    }

    onBtnClick = () => {
        const { showGlobalLoader } = this.props;
        if (!showGlobalLoader) {
            document.body.style.position = 'relative'; // MCYODA-13805: After delay spinner, change position
            this.setState({
                expandForm: !this.state.expandForm,
            });
        }
    };

    /* istanbul ignore next */ scrollToElement = (element) => {
        scrollToElement(element);
    };

    signInCallBack = (e) => {
        e?.preventDefault();
        const el = e?.target?.closest('A');
        if (el && e?.currentTarget?.contains(el)) {
            this.setState({
                expandForm: false,
            });
        }
    };

    renderAccountForm = () => {
        if (this.state.expandForm) {
            return (
                <>
                    <h3
                        className={`${cx('header')} ${dt([
                            'font-open-sans-semibold',
                            'text-black',
                            'text-center',
                            'mb-2',
                            'text-xlarge',
                        ])}`}
                    >
                        {signInPageLabels.CREATE_ACCOUNT_TITLE}
                    </h3>
                    <p
                        className={`${cx('topText')} ${dt([
                            'text-center',
                            'text-medium',
                            'text-black',
                            'mb-6',
                        ])}`}
                    >
                        {signInPageLabels.CREATE_ACCOUNT_SUBTITLE_NEW}
                    </p>
                    <CreateAccountPage
                        cartSigninInfo={{
                            isCartSigninPage: true,
                            scrollToElement: this.scrollToElement,
                            checkoutSessionInit: this.props.checkoutSessionInit,
                        }}
                        signInCallBack={this.signInCallBack}
                    />
                    <p
                        className={`${cx('termsText')} ${dt([
                            'text-left',
                            'text-xsmall',
                            'text-gray-60',
                            'lg:w-[300px]',
                            'text-center',
                            'lg:m-auto',
                        ])}`}
                    >
                        {signInPageLabels.AGREEMENT_FIRST}{' '}
                        <a
                            rel="noopener noreferrer"
                            target="_blank"
                            href={signInPageLabels.AGREEMENT_URL}
                            className={dt(['underline', 'text-gray-60'])}
                        >
                            Terms &amp; Conditions
                        </a>{' '}
                        {signInPageLabels.AGREEMENT_SECOND}
                    </p>
                </>
            );
        }
        return (
            <Button
                automationId="at-create-account-button"
                buttonType="Secondary"
                size="Lg"
                type="button"
                onClick={this.onBtnClick}
                className={dt(['lg:max-w-[300px]', 'w-full', 'mx-auto'])}
            >
                {signInPageLabels.CREATE_ACCOUNT_TITLE}
            </Button>
        );
    };

    render() {
        return (
            <div className={`${cx('mainContainer')} ${dt(['flex', 'flex-col'])}`}>
                {this.renderAccountForm()}
            </div>
        );
    }
}
export default CreateAccountButton;
